<template>
  <div class="container">

    <div class="navi">
        <span class="close"><span class="icon-arrow-left" @click="goto('/clean-switch')"></span></span>
        <div class="top-title">退房清洁价格表</div>
        <span></span>
    </div>
    <img class="bg-logo" src="../../assets/img/index/logo.svg">
    <div class="bg-title">长租房退房清洁</div>
    <div class="bg-title-sub">计费方式及价格表</div>

    <div class="formula">
      <img src='/static/img/clean/gs.png'>
      <div class="subtitle">
        基础收费包含内容参考下方详情，特殊/额外收费需服务人员上门后根据现场卫生情况与您协商。
      </div>
    </div>

    <div class="core">
      <div class="title">基础费用</div>
      <div class="subtitle">费用随户型大小变化，请参考下表报价<br>基础费用所涵盖的清洁项目内容如下</div>


      <div class="special-cleaning pricing-zone fee-padding">
        <div class="row">
          <div class="content specific-item"><div class="specific-item">包含项目</div><span>客厅卧室打扫，拖地，吸尘</span><span>厕所</span><span>洗衣房</span><span>4扇落地玻璃窗</span><span>5扇小玻璃窗</span><span>门</span><span>开关</span><span>插座</span><span>厨房炉灶，操作台面</span><span>橱柜衣柜表内清洁</span></div>
        </div>

        <div class="row">
          <div class="content specific-item"><div class="specific-item">不含项目</div><span>厨房油烟机</span><span>烤箱</span><span>地毯清洁</span><span>阳台</span><span>墙面可擦污渍清洁</span></div>
        </div>

      </div>

      <div class="main pricing-zone clearfix">
        <div class="cell cell-tall">
          <div class="type">单主卧<br>Master Room</div>
          <div class="description">$100</div>
        </div>
        <div class="cell cell-tall">
          <div class="type">一室一卫 /<br> 一房Studio</div>
          <div class="description"> $110</div>
        </div>
        <div class="cell">
          <div class="type">两室一卫</div>
          <div class="description">$150</div>
        </div>
        <div class="cell">
          <div class="type">两室两卫</div>
          <div class="description"> $180</div>
        </div>
        <div class="cell" >
          <div class="type">三室一卫</div>
          <div class="description">$180</div>
        </div>
        <div class="cell">
          <div class="type">三室两卫</div>
          <div class="description">$220</div>
        </div>
        <div class="dual-cell" @click="orderUpdate('house_type','1');">
          <div class="type">其他户型 <span style="color:#888">/</span> 别墅户型</div>
          <div class="description">需现场评估确定</div>
        </div>
      </div>


      <div class="title">特殊费用</div>
      <div class="subtitle">包括复式房型、楼梯费、特殊房间等的费用</div>
      <div class="special-cleaning pricing-zone">
        <div class="row">
          <div class="name">复式房型</div>
          <div class="content">如果您的房屋是复式房型，我们将根据实际情况额外收取 <span class="color-orange">$30 ~ $50</span></div>
        </div>

        <div class="row">
          <div class="name">楼梯费</div>
          <div class="content">如果您的房子在高层且没有电梯，我们将收取额外的楼梯费；<br>复式户型也会产生额外楼梯费<br><span class="color-orange">每层收费 $10</span></div>
        </div>

        <div class="row">
          <div class="name">特殊区域</div>
          <div class="content">如果您的房屋还有以下区域，将产生额外的费用：车库、游泳池、前院、后院、仓库</div>
        </div>
      </div>


      <div class="title">额外项目收费</div>
      <div class="subtitle">下列清洁项目需要额外收费<br>如需进行，可与服务人员当面协商</div>
      <div class="extra-cleaning pricing-zone">
      <div class="item">
        <div class="item-head" @click ="item1 = !item1">
          <span class="itemtext">地毯清洁</span>
          <span class="icon-chevron-down"  v-show="!item1"></span>
          <span class="icon-chevron-up"  v-show="item1"></span>
        </div>

        <div class="item-detail" v-show="item1">
          <div class="detail clearfix">
            <span class="pull-left">洗地毯1房</span>
            <span class="pull-right">$70</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗地毯2房</span>
            <span class="pull-right">$80</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗地毯3房</span>
            <span class="pull-right">$90</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗地毯4房</span>
            <span class="pull-right">$120</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗地毯5房</span>
            <span class="pull-right">$150</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">楼梯洗地毯</span>
            <span class="pull-right">$30 / 层</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">地毯机楼层搬运（电梯楼免费）</span>
            <span class="pull-right">$20 / 层</span>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="item-head" @click ="item2 = !item2">
          <span class="itemtext">门窗深度清洁</span>
          <span class="icon-chevron-down"  v-show="!item2"></span>
          <span class="icon-chevron-up"  v-show="item2"></span>
        </div>

        <div class="item-detail" v-show="item2">
          <div class="detail clearfix">
            <span class="pull-left">落地拉门超过4扇</span>
            <span class="pull-right">$15 / 扇</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">窗户玻璃超过5扇</span>
            <span class="pull-right">$5 / 扇</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">百叶窗清洁只弹灰尘</span>
            <span class="pull-right">免费</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">深度清理百叶窗</span>
            <span class="pull-right">$20 - $50 / 组</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">纱窗</span>
            <span class="pull-right">$15 / 扇</span>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="item-head" @click ="item3 = !item3">
          <span class="itemtext">厨房深度清洁</span>
          <span class="icon-chevron-down"  v-show="!item3"></span>
          <span class="icon-chevron-up"  v-show="item3"></span>
        </div>

        <div class="item-detail" v-show="item3">
          <div class="detail clearfix">
            <span class="pull-left">微波炉</span>
            <span class="pull-right">$10 - $20</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">冰箱</span>
            <span class="pull-right">$20 - $50</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗碗机</span>
            <span class="pull-right">$30</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">厨房油渍太重</span>
            <span class="pull-right">$30 - $50</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">烤箱重度清洁</span>
            <span class="pull-right">$30 - $50</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">油烟机重度清洁</span>
            <span class="pull-right">$30 - $50</span>
          </div>

        </div>
      </div>

      <div class="item last">
        <div class="item-head" @click ="item4 = !item4">
          <span class="itemtext">其他清洁</span>
          <span class="icon-chevron-down"  v-show="!item4"></span>
          <span class="icon-chevron-up"  v-show="item4"></span>
        </div>

        <div class="item-detail" v-show="item4">
          <div class="detail clearfix">
            <span class="pull-left">墙面可擦洗污渍清洁</span>
            <span class="pull-right">$15 / 面</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">墙面发霉</span>
            <span class="pull-right">$15 / 扇</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">阳台清洁</span>
            <span class="pull-right">$10 - $50</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">生活垃圾清洁</span>
            <span class="pull-right">$30起</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">宠物清洁</span>
            <span class="pull-right">现场评估</span>
          </div>
        </div>
        
      </div>
      </div>
    </div>
    <div class="btn-box-fix">
      <div class="btn-container">
        <a href="javascript:void(0)" class="btn active" @click="$router.push('/clean-step1')">下单退房清洁</a>
      </div>
    </div>
    <img :src="pixelURL('clean','step0baojia')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'clean-step6',
  data () {
    return {
      item1:true,
      item2:true,
      item3:true,
      item4:true,
    }
  },
  mounted: function () {
    document.querySelector("html").classList.add("pricing-bg");
  },
  destroyed() {
    document.querySelector("html").classList.remove("pricing-bg");
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.formula{
  text-align:center;
  margin:20px 0 0 0;
  img{
    width:90%;
  }
  div{
    padding:0 20px;
  }
}

.title{
  padding-bottom:4px;
}

.detail{
  padding:1px 4px;
  font-size:0.8em;
  color:#777;
}

.core{
  padding:18px;
  margin-top:20px;
}

.subtitle{
  text-align:center;
  font-size:0.9em;
  color:#888;
}

.item-detail{
  margin-top:8px;
}

.item{
  font-size:1.2em;
  padding:12px 0;
  border-bottom:1px solid #eee;
  .icon-chevron-down{
    float:right;
    line-height:1.6em;
  }
  .icon-chevron-up{
    float:right;
    line-height:1.6em;
  }
}

.btn{
	width:300px;
	height: 50px;
	cursor: pointer;
	background: #eee;
	color:#666;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50px;
	font-size: 1.2em;
    font-weight: 100;
    margin: 0 auto;
    margin-top: 12px;
    max-width:100%;
}

.btn-box{
    background:rgba(255,255,255,1);
    box-shadow: -1px -1px 8px rgba(40,40,40,0.1);
    border-top:1px solid #eee;
    position: fixed;
    bottom: 0px;
    padding-bottom:15px;
    text-align:center;
    width:100%;
    box-sizing:border-box;
    z-index:99;
}
.btn.active{
    color:#fff;
	background: rgb(237,121,75);
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 100%);
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
    box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

.btn:active{
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 50%);
}

.cell{
	float:left;
	width:50%;
	border-bottom:1px solid #eee;
	box-sizing: border-box;
	height: 100px;
	text-align: center;
	cursor: pointer;
}
.cell-tall{
	height: 120px;
}

.cell:active{
	background: #eee;
}
.cell:nth-child(odd) {
	border-right:1px solid #eee;
}
.cell.last, .item.last{
	border-bottom:0;
}
.cell img{
	width:60px;
}

.type{
	font-size:1.1em;
	font-weight:bold;
	color:#5A5C68;
	margin-top:25px;
  line-height:1.3;
}
.description{
	color:#fe9567;
	font-size:1.2em;
  margin-top:5px;
}

.dual-cell{
  float:left;
  width:100%;
  text-align:center;
  height:100px;
}

.pricing-zone{
    border: 1px solid #eee;
    background:#fff;
    border-radius: 8px;
    -webkit-box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.8);
    box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.8);
    margin-top:20px;
    margin-bottom: 40px;
}

.extra-cleaning{
  padding:4px 20px;
}

.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}
.bg-logo{
  width:240px;
  position:absolute;
  top:70px;
  left:24px;
}


.bg-title{
  color:#fff;
  font-size:2em;
  font-weight:bold;
  margin-top:114px;
  margin-left:22px;
}

.bg-title-sub{
  font-size:1.1em;
  font-weight:bold;
  color:#fff;
  margin-left:22px;
}

.special-cleaning {
  padding:20px 0;
  .row{
    display: flex;
    justify-content:left;
    align-items:left;
    margin-bottom:10px;
    .name{
      flex:1;
      padding:4px 0 0 14px;
      font-size:1em;
    }
    .content{
      flex:3;
      padding:4px 10px;
      font-size:0.9em;
      color:#666;
    }
  }
}

.specific-item{
  span{
    background:#FAEEE3;
    color:#5A5D67;
    padding:3px 6px;
    border-radius:4px;
    margin-right:10px;
    display:inline-block;
    margin-bottom:8px;
  }
  .specific-item{
      font-size:1.2em;
      display:inline-block;
      font-weight:bold;
      margin-right:20px;
  }
}

.fee-padding{
  padding:20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/clean/step0.vue